require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-jennifer-rue.json") })
        }
      }, "path---articles-tags-jennifer-rue");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-jennifer-rue!./.cache/json/articles-tags-jennifer-rue.json
// module id = 1866
// module chunks = 231608221292675